import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import router from './router/index.js'
import store from './store/index.js'
import './mock/mock.js'
import Print from 'vue-print-nb'
import {vaildte} from './utils/validate.js'

Vue.config.productionTip = false
Vue.prototype.$vaildte = vaildte

Vue.use(ElementUI);
Vue.use(Print);


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
